import { Link } from "react-router-dom";
import { Phone, MessageCircle, ClipboardList } from "lucide-react";
import { CONTACT, WHATSAPP_DEFAULT } from "@/data/content";

export default function StickyDock() {
  return (
    <>
      {/* Mobile bottom bar */}
      <div data-testid="mobile-sticky-bar" className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-3 border-t border-slate-200 bg-white/95 backdrop-blur-xl md:hidden">
        <a href={`tel:${CONTACT.phonePrimaryRaw}`} data-testid="sticky-call-btn"
          className="flex flex-col items-center gap-1 py-3 text-navy">
          <Phone className="h-5 w-5" />
          <span className="text-[11px] font-bold">Call Now</span>
        </a>
        <a href={WHATSAPP_DEFAULT} target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp-btn"
          className="flex flex-col items-center gap-1 py-3 text-[#128C7E]">
          <MessageCircle className="h-5 w-5" />
          <span className="text-[11px] font-bold">WhatsApp</span>
        </a>
        <Link to="/quote" data-testid="sticky-quote-btn"
          className="flex flex-col items-center gap-1 bg-navy py-3 text-amber-400">
          <ClipboardList className="h-5 w-5" />
          <span className="text-[11px] font-bold">Get Quote</span>
        </Link>
      </div>

      {/* Desktop floating dock */}
      <div data-testid="desktop-sticky-dock" className="fixed bottom-6 right-6 z-50 hidden md:flex flex-col gap-3">
        <a href={WHATSAPP_DEFAULT} target="_blank" rel="noopener noreferrer" data-testid="dock-whatsapp-btn"
          aria-label="Chat on WhatsApp"
          className="cta-gleam flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg">
          <MessageCircle className="h-6 w-6" />
        </a>
        <a href={`tel:${CONTACT.phonePrimaryRaw}`} data-testid="dock-call-btn"
          aria-label={`Call ${CONTACT.phonePrimary}`}
          className="cta-gleam flex h-14 w-14 items-center justify-center rounded-full bg-navy text-amber-400 shadow-lg">
          <Phone className="h-6 w-6" />
        </a>
      </div>
    </>
  );
}
